import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { RouterProvider, createBrowserRouter } from 'react-router-dom';
import Store from './Components/ReduxStore';
import { ThemeProvider, createTheme } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import routes from './routes'; // assuming routes are defined here
import './index.css';

const theme = createTheme({
  palette: {
    primary: { main: "#1976d2" },
    secondary: { main: "#dc004e" },
    success: { main: "#4caf50" },
    error: { main: "#f44336" },
    background: { default: "#f4f6f8" },
  },
});

// Set up the router with future flags
const router = createBrowserRouter(routes, {
  future: {
    v7_startTransition: true,
  },
});

const root = createRoot(document.getElementById('root'));

root.render(
  <ThemeProvider theme={theme}>
    <CssBaseline />
    <Provider store={Store}>
      <RouterProvider router={router}   future={{
    v7_startTransition: true,
    v7_relativeSplatPath: true
  }}/>
    </Provider>
  </ThemeProvider>
);
